import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { checkPayment } from "../redux/actions/PaymentActions";
import { ScaleLoader } from "react-spinners";
import { Button, Container } from "react-bootstrap";

// Where the client goes after a card payment, by page he paid from
const NEXT_PAGE = {
  cart: { paid: "/finalization", unpaid: "/cart" },
  formality: { paid: "/formality-finalization", unpaid: "/formality-payment" },
  dashboard: { paid: "/user/subscriptions", unpaid: "/user/subscriptions" },
};

// Time left to the client to pay in the provider's tab (3 s per check)
const WAIT_ATTEMPTS = 300;

// Return page of the card payment: the result is always read from the server
const CheckPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.authUser);
  const dispatch = useDispatch();
  const { cardPayment, paymentFrom } = useSelector((state) => state.payments);
  const params = new URLSearchParams(location.search);
  const success = params.get("success");
  const reference = params.get("ref") || cardPayment?.reference;
  // Without a result in the address, the client pays in another tab
  const payingInOtherTab = success === null;
  const active = useRef(true);
  const next = NEXT_PAGE[paymentFrom] || {
    paid: "/formality-finalization",
    unpaid: "/",
  };
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
  });

  const handleCheckPaymentCallback = ({ success: paid, message }) => {
    if (paid) {
      Toast.fire({ icon: "success", title: "Succès", text: message });
      navigate(next.paid, { replace: true });
    } else {
      Toast.fire({
        icon: "error",
        title: "Paiement non abouti",
        text: "Le paiement par carte n'a pas abouti. Vous pouvez réessayer ou choisir un autre moyen de paiement.",
      });
      navigate(next.unpaid, { replace: true });
    }
  };

  useEffect(() => {
    active.current = true;

    if (!user?.token || !reference) {
      navigate("/", { replace: true });
      return;
    }

    dispatch(
      checkPayment(
        user.token,
        reference,
        cardPayment?.request,
        handleCheckPaymentCallback,
        // After a failure the status is read once. Otherwise (success, or a
        // payment made in another tab) we wait for the confirmation
        success === "false" ? 0 : WAIT_ATTEMPTS,
        () => active.current,
      ),
    );

    return () => {
      active.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const reopenPaymentPage = () => {
    const tab = window.open(cardPayment.paymentUrl, "_blank");

    if (tab) tab.opener = null;
  };

  return (
    <Container fluid style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "16px",
          height: "50vh",
          width: "100%",
        }}
      >
        <ScaleLoader color="#051259" aria-label="Chargement" />
        <p style={{ color: "#051259", margin: 0 }}>
          Vérification de votre paiement…
        </p>
        {payingInOtherTab && cardPayment?.paymentUrl && (
          <>
            <p
              style={{
                color: "#5b6275",
                margin: 0,
                maxWidth: "420px",
                textAlign: "center",
              }}
            >
              Terminez votre paiement dans l'onglet de notre partenaire de
              paiement. Cette page se met à jour toute seule.
            </p>
            <Button
              variant="outline-secondary"
              style={{ borderRadius: "16px" }}
              onClick={reopenPaymentPage}
            >
              Ouvrir la page de paiement
            </Button>
          </>
        )}
      </div>
    </Container>
  );
};

export default CheckPayment;
